import React, { useEffect, useState } from 'react';
import { adminNoticeAPI, adminNoticeSaveAPI } from '../../api/admin';
import { Card, Field, Input, Textarea, Toggle, Btn, Row, Grid, Msg, toLocalInput } from './ui';

// 공지 · 상단 배너 — 첫 방문 모달(제목·배지·본문·일정)과 헤더 아래 띠 문구, 노출 기간
const empty = { enabled: true, showModal: true, showBanner: true, title: '', badge: '', lines: '', schedule: '', bannerText: '', startAt: '', endAt: '' };

function AdminNotice() {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ ok: false, text: '' });

  const load = (n) => setForm({
    enabled: n.enabled, showModal: n.showModal, showBanner: n.showBanner,
    title: n.title || '', badge: n.badge || '', lines: (n.lines || []).join('\n'), schedule: n.schedule || '', bannerText: n.bannerText || '',
    startAt: toLocalInput(n.startAt), endAt: toLocalInput(n.endAt),
  });

  useEffect(() => {
    adminNoticeAPI().then((resp) => {
      if (resp && resp.status === 200 && resp.data.notice) load(resp.data.notice);
      else setMsg({ ok: false, text: (resp && resp.data && resp.data.message) || '불러오지 못했습니다.' });
    });
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e && e.target ? e.target.value : e }));

  const save = async () => {
    setBusy(true);
    setMsg({ ok: false, text: '' });
    const resp = await adminNoticeSaveAPI({
      ...form,
      lines: form.lines.split('\n').map((s) => s.trim()).filter(Boolean),
      startAt: form.startAt ? new Date(form.startAt).toISOString() : null,
      endAt: form.endAt ? new Date(form.endAt).toISOString() : null,
    });
    setBusy(false);
    if (resp && resp.status === 200) { load(resp.data.notice); setMsg({ ok: true, text: '저장했습니다.' }); }
    else setMsg({ ok: false, text: (resp && resp.data && resp.data.message) || '저장하지 못했습니다.' });
  };

  return (
    <React.Fragment>
      <Card title="노출" desc="사이트 전체에 보이는 공지 모달과 상단 띠">
        <Row>
          <Toggle checked={form.enabled} onChange={set('enabled')} label="공지 켜기" />
          <Toggle checked={form.showModal} onChange={set('showModal')} label="첫 방문 모달" />
          <Toggle checked={form.showBanner} onChange={set('showBanner')} label="상단 띠" />
        </Row>
        <Grid cols={2} className="" >
          <Field label="시작"><Input type="datetime-local" value={form.startAt} onChange={set('startAt')} /></Field>
          <Field label="종료"><Input type="datetime-local" value={form.endAt} onChange={set('endAt')} /></Field>
        </Grid>
      </Card>
      <Card title="모달" desc="첫 방문에 뜨는 안내">
        <Grid cols={2}>
          <Field label="제목"><Input value={form.title} onChange={set('title')} placeholder="홈페이지 보수작업 진행 중" /></Field>
          <Field label="배지"><Input value={form.badge} onChange={set('badge')} placeholder="11월 내 런칭 예정" /></Field>
        </Grid>
        <Field label="본문 (줄마다 한 문장)"><Textarea value={form.lines} onChange={set('lines')} /></Field>
        <Field label="일정 상자"><Input value={form.schedule} onChange={set('schedule')} placeholder="2026년 11월 내 정식 오픈 예정" /></Field>
      </Card>
      <Card title="상단 띠" desc="헤더 아래 한 줄">
        <Field label="띠 문구"><Input value={form.bannerText} onChange={set('bannerText')} placeholder="홈페이지 보수작업 진행 중 · 11월 내 런칭 예정" /></Field>
        <Row>
          <Btn onClick={save} disabled={busy}>{busy ? '저장 중' : '저장'}</Btn>
          <Msg ok={msg.ok}>{msg.text}</Msg>
        </Row>
      </Card>
    </React.Fragment>
  );
}

export default AdminNotice;
